module.exports = __webpack_public_path__ + "static/media/right-arrow.3a1dc2a9.svg";